// Ref-counted body scroll lock, so overlapping overlays (mobile menu → clinic picker)
// don't unlock the page while another overlay is still open.
let locks = 0;

export function lockBodyScroll() {
  if (locks++ === 0) document.body.style.overflow = "hidden";
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--locks === 0) document.body.style.overflow = "";
  };
}
